import React from 'react';
import { CatalogPageSEOLinkCandidate } from '@interfaces/api/responses/catalog-page-seo-links-response';
import Link from '@components/atoms/link/link';
import styles from './seo-links.module.scss';

export type SEOLinksProps = {
  candidates: CatalogPageSEOLinkCandidate[];
};

const SEOLinks: React.FC<SEOLinksProps> = (props): React.JSX.Element => {
  const { candidates } = props;

  return (
    <div className={styles['seo-links']}>
      <ul>
        {candidates.map((seoLinkCandidate: CatalogPageSEOLinkCandidate) => (
          <Link
            key={seoLinkCandidate.path}
            href={seoLinkCandidate.path}
            className={styles['seo-links__link']}
          >
            {seoLinkCandidate.label}
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default SEOLinks;
